/**
 * The readable text of a value that may carry markup.
 *
 * The product descriptions are kept as markup and rendered as such where there
 * is room for it. In a table cell and in a one-line header there is not, and
 * the tags were read out as text: a position said "Schlauch<br/><br/>DN 25"
 * (#2215, R-59). Line breaks and block ends become a space, everything else
 * goes, and the handful of entities that actually occur are turned back.
 */
export const plainFromMarkup = (value: string): string =>
    value
        .replace(/<\s*(br|\/p|\/div|\/li|\/tr)\s*\/?\s*>/gi, ' ')
        .replace(/<[^>]*>/g, '')
        .replace(/&nbsp;/gi, ' ')
        .replace(/&amp;/gi, '&')
        .replace(/&lt;/gi, '<')
        .replace(/&gt;/gi, '>')
        .replace(/&quot;/gi, '"')
        .replace(/&#39;/g, "'")
        .replace(/\s+/g, ' ')
        .trim();
